import type { ReactNode } from "react";
import { cx } from "../cx";
import styles from "./Badge.module.css";

export type BadgeTone = "primary" | "success" | "warning" | "danger" | "neutral" | "disabled";

export interface BadgeProps {
  children?: ReactNode;
  tone?: BadgeTone;
  className?: string;
}

/** Legacy cl-badge: 10px text, 5px 10px padding, 2px radius. */
export function Badge({ children, tone = "primary", className }: BadgeProps) {
  return <span className={cx(styles.badge, styles[tone], className)}>{children}</span>;
}

export interface CountBadgeProps {
  count: number;
  /** Above this the badge reads `<max>+` (the bell shows 9+). */
  max?: number;
  /** A bare dot without a number (APPROVALS pending marker). */
  dot?: boolean;
  className?: string;
  "aria-label"?: string;
}

export function CountBadge({ count, max = 9, dot, className, ...rest }: CountBadgeProps) {
  if (count <= 0) return null;
  return (
    <span role="status" className={cx(styles.count, dot && styles.dot, className)} aria-label={rest["aria-label"]}>
      {dot ? null : count > max ? `${max}+` : count}
    </span>
  );
}
